import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-editor-toolbar',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './editor-toolbar.component.html',
  styleUrl: './editor-toolbar.component.scss'
})
export class EditorToolbarComponent {
  @Input() currentTitle = '';
  @Input() currentTypeLabel = '';
  @Input() version: number;
  @Input() mainSaveState: 'idle' | 'saving' | 'success' = 'idle';
  @Input() saveAsState: 'idle' | 'saving' | 'success' = 'idle';
  @Input() saveState: 'idle' | 'saving' | 'success' = 'idle';
  @Input() canUndo = false;
  @Input() canRedo = false;
  @Input() isDualPane = false;
  @Input() isViewingDiff = false;
  @Input() showVersionsModal = false;
  @Input() searchTerm = '';
  @Input() showNewTrainingPane = false;
  @Input() hasName = false;
  @Input() copySourceJsonState: 'idle' | 'success' = 'idle';

  @Output() undoClick = new EventEmitter<void>();
  @Output() redoClick = new EventEmitter<void>();
  @Output() saveClick = new EventEmitter<void>();
  @Output() openSaveAsClick = new EventEmitter<void>();
  @Output() toggleVersionsClick = new EventEmitter<void>();
  @Output() livePreviewClick = new EventEmitter<void>();
  @Output() toggleDualPaneClick = new EventEmitter<void>();
  @Output() copySourceJsonClick = new EventEmitter<void>();
  @Output() searchChange = new EventEmitter<string>();
  @Output() copySourceClick = new EventEmitter<void>();
  @Output() saveNewTrainingClick = new EventEmitter<void>();
  @Output() closeNewTrainingClick = new EventEmitter<void>();
}
